import React from 'react';
import { GRID_SIZE } from './constants';
import type { FacilityEntity } from '@/types/facility';
import { BayObject } from './BayObject';

interface FacilityCanvasProps {
  entities: FacilityEntity[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  onDeselect: () => void;
  onMove: (id: string, x: number, y: number, soloMove?: boolean) => void;
  onResize: (id: string, w: number, h: number) => void;
}

export function FacilityCanvas({
  entities, selectedId, onSelect, onDeselect, onMove, onResize,
}: FacilityCanvasProps) {
  return (
    <div
      className="relative w-[6000px] h-[4000px]"
      onPointerDown={(e) => {
        // Deselect only when clicking directly on empty canvas (not on a bay)
        if (!(e.target as HTMLElement).closest('[data-bay-object]')) {
          onDeselect();
        }
      }}
      style={{
        backgroundImage: `radial-gradient(circle, hsl(var(--border) / 0.4) 1px, transparent 1px)`,
        backgroundSize: `${GRID_SIZE}px ${GRID_SIZE}px`,
        backgroundPosition: '0 0',
      }}
    >
      {entities.map(entity => (
        <BayObject
          key={entity.id}
          entity={entity}
          isSelected={selectedId === entity.id}
          onSelect={onSelect}
          onMove={onMove}
          onResize={onResize}
        />
      ))}
    </div>
  );
}
